
export class Managerproperty {

  public id : any;
  public countries : any = [];
  public zipcodes : string;

  constructor() {}


}
